import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import ApiTransferencias from "./modules/ApiTransferencias";
import Comitente from "./modules/Comitente";
import Recursos from "./modules/Recursos";
import Amedia from "./modules/Amedia";
import ExternalAccounts from "./modules/ExternalAccounts";

export default new Vuex.Store({
  modules: {
    ApiTransferencias,
    Recursos,
    Comitente,
    Amedia,
    ExternalAccounts,
  },
});
